import React from 'react';
import { useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Star toggle for a "favourite product" row (utilization report, inventory leakage).
 * Stops propagation — the row itself usually opens a drawer/detail modal.
 */
export const FavoriteStar: React.FC<{ isFavorite: boolean; onToggle: () => void; disabled?: boolean }> = ({ isFavorite, onToggle, disabled = false }) => {
  const { t } = useTranslation();
  const label = t(isFavorite ? 'reports.utilization.favorites.remove' : 'reports.utilization.favorites.add');
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      title={label}
      aria-label={label}
      className="p-1 -ml-1 shrink-0 rounded-md hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
    >
      <Star className={cn('w-4 h-4', isFavorite ? 'fill-[#F79009] dark:fill-[#F79009] text-[#F79009]' : 'text-muted dark:text-muted-dark')} />
    </button>
  );
};

export default FavoriteStar;
